import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

class Case extends PureComponent {
  render() {
    return <div>{this.props.children}</div>
  }
}

Case.propTypes = {
  // value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.node.isRequired
}

export default Case
